import { createSlice } from '@reduxjs/toolkit';
import { getStudyTopicsApi } from '../../../rtk-apis/reports/getStudyTopicsApi';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const getStudyTopicsSlice = createSlice({
  name: 'getStudyTopics',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getStudyTopicsApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getStudyTopicsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.msg = action?.payload?.msg;
        state.result = action?.payload;
      })
      .addCase(getStudyTopicsApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = action?.payload as string;
        state.result = (action?.payload as string) || '';
      });
  },
});

export const { clearState } = getStudyTopicsSlice.actions;
export default getStudyTopicsSlice.reducer;
